import type { ProvidersServiceAPI } from '@wix/editor-platform-feature-store';
import type { CompRef } from '@wix/document-services-types';

import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { DependencyToken } from '../dependencies';

import type { EditorPointer } from '@wix/editor-document-logic-api';

export class ExternalProvidersHandler extends AbstractExternalAPIHandler {
  list(options: Parameters<ProvidersServiceAPI['list']>[0]) {
    return this.dependenciesContributor.get(DependencyToken.PROVIDERS_LIST)(
      options,
    );
  }

  attach(
    editorPointer: EditorPointer<CompRef>,
    providerIdentifier: string,
    data?: Object,
  ) {
    return this.dependenciesContributor.get(DependencyToken.PROVIDERS_ATTACH)(
      editorPointer,
      providerIdentifier,
      data,
    );
  }

  detach(editorPointer: EditorPointer<CompRef>, providerIdentifier: string) {
    return this.dependenciesContributor.get(DependencyToken.PROVIDERS_DETACH)(
      editorPointer,
      providerIdentifier,
    );
  }

  getData(editorPointer: EditorPointer<CompRef>, providerIdentifier: string) {
    return this.dependenciesContributor.get(DependencyToken.PROVIDERS_GET_DATA)(
      editorPointer,
      providerIdentifier,
    );
  }

  updateData(
    editorPointer: EditorPointer<CompRef>,
    providerIdentifier: string,
    data: Record<string, unknown>,
  ) {
    return this.dependenciesContributor.get(
      DependencyToken.PROVIDERS_UPDATE_DATA,
    )(editorPointer, providerIdentifier, data);
  }
}
